<div class="fixed top-0 left-0 right-0 z-50 flex justify-center px-4 pt-3 pointer-events-none">
  <div class="w-full max-w-xl flex items-center justify-between gap-2 bg-white border border-solid border-primary/60 rounded-lg shadow-lg p-3 pointer-events-auto">
    <div class="flex items-center gap-2">
      <mat-icon [svgIcon]="svgIcon" class="text-default-dark"></mat-icon>
      <span class="text-default-dark font-medium text-sm">{{ messageKey | translate }}</span>
    </div>
    <app-close-chip (closed)="dismissed.emit()" />
  </div>
</div>
